
import WDElement from '../wd-element';
import WDButton from '../button/wd-button';
import WDUtil from '../../core/wd-util';

export default class WDNavbarMenu extends WDElement
{

	#toggleButton;
	#wrapper;
	#navbar;
	#list;
	#config = {
		toggle_icon: 'fa-solid fa-bars',
	};

	constructor(cfg)
	{
		super().classList.add('wd-navbar-menu');

		this.#wrapper = wdc('<div class="wd-navbar-menu-wrapper"/>');
		this.#list = wdc('<ul class="wd-navbar-menu-list"/>');

		this.#wrapper.append(this.#list);
		this.append(this.#wrapper);

		if (cfg) WDUtil.merge(this.#config, cfg);
	}

	get navbar()
	{
		if (!this.#navbar) this.#navbar = this.closest('.wd-navbar');
		return this.#navbar;
	}

	get list() { return this.#list; };
	get items() { return this.#list.children; };
	get itemArray() { return [...this.#list.children]; };

	set collapseMode(val)
	{
		this.navbar.collapsible = val;

		if (val === false) 
		{
			this.navbar.collapsible = false;
			delete this.dataset.collapseMode;
		}
		else
		{
			if (val === true) val = 'menu';
			this.dataset.collapseMode = val;
		}
	};

	//	
	add(cfg)
	{
		const btn = new WDButton(cfg);

		//add to our common container
		this.addItem(btn);

		return btn;
	};

	addAtIndex(title, cfg, idx)
	{
		const btn = new WDButton(title, cfg);
		const item = this.addItem(btn);

		//add to our common container
		this.addItemAtIndex(item, idx);

		return btn;
	};

	addDivider()
	{
		const item = wdc('<li class="wd-navbar-menu-divider"/>');
		this.#list.append(item);
	};

	addItem(obj)
	{
		const item = wdc('<li class="wd-navbar-menu-item"/>');
		if (obj) item.append(obj);

		//add to object
		this.#list.append(item);

		return item;
	};

	addText(str)
	{
		const item = this.addItem(str);
		item.classList.add('wd-navbar-menu-text');

		return item;
	};

	empty()
	{
		this.#list.replaceChildren();
		return this;
	};

	addItemAtIndex(item, idx)
	{
		const items = this.#list.querySelectorAll('.wd-navbar-menu-item');

		if (idx == 0) this.#list.prepend(item);
		else if (idx == items.length - 1) this.#list.append(item);
		else items[idx].before(item);

		return item;
	};

	removeItem(item)
	{
		item.remove();
	};

	/** remove menu item at specified index **/
	removeAtIndex(idx)
	{
		const items = this.#list.querySelectorAll('.wd-navbar-menu-item');
		wdc(items[idx]).remove();
	};

	/** remove all items after the passed element **/
	removeAfterItem(item)
	{
		const items = this.#list.querySelectorAll('.wd-navbar-menu-item');
		const idx = items.indexOf(item.element());
		this.removeAfterIndex(idx);
	};

	/** remove all items after the passed index **/
	removeAfterIndex(idx)
	{
		idx = parseInt(idx) + 1;
		const items = this.#list.querySelectorAll('.wd-navbar-menu-item');

		for (const itemIdx in items)
		{
			if (itemIdx > idx) items[itemIdx].remove();
		}
	};

	cleanupCallback()
	{
		// Clean up toggle button
		if (this.#toggleButton) {
			this.#toggleButton = null;
		}

		// Clear references
		this.#wrapper = null;
		this.#list = null;
		this.#navbar = null;
		this.#config = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-navbar-menu', WDNavbarMenu);
